import { render, staticRenderFns } from "./MovieCategory.vue?vue&type=template&id=7d0c42b4&scoped=true"
import script from "./MovieCategory.vue?vue&type=script&lang=js"
export * from "./MovieCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0c42b4",
  null
  
)

export default component.exports